import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import CheckboxGroup from "components/InputsField/formikInputs/CheckboxGroup";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";

import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";
const ExtraOptions = () => {
    const { t } = useTranslation();
    const lang = useSelector((state) => state.settings.lang);

    return (
        <>
            <div className={styles.extraRow}>
                <div className={styles.fieldWide}>
                    <AsyncSelect
                        url={`${UTILS}/paymentTypes/?lang=${lang}`}
                        label={t("cargoSearch.additional_field.rate")}
                        name="payment_types_ids"
                        isClearable={true}
                        isMulti
                    />
                </div>
                <div className={styles.fieldNarrow}>
                    <AsyncSelect
                        url={`${UTILS}/transportation-types/?lang=${lang}`}
                        label={t("cargoSearch.additional_field.loading_mode_label")}
                        name="transportation_type_id"
                        isClearable={true}
                    />
                </div>
                <div className={styles.fieldNarrow}>
                    <AsyncSelect
                        url={`${UTILS}/packages/?lang=${lang}`}
                        label={t("cargoSearch.additional_field.package")}
                        name="package_ids"
                        isClearable={true}
                        isMulti
                        maxDisplayedValues={2}
                        sort
                    />
                </div>
            </div>
            <div className={styles.checkboxes}>
                <CheckboxGroup
                    checkboxes={[
                        <FormikCheckboxField
                            name="conics"
                            id="conics"
                            label={t("cargoSearch.additional_field.bolsters_box")}
                        />,
                        <FormikCheckboxField
                            name="adr"
                            id="adr"
                            label={t("cargoSearch.additional_field.adr_box")}
                        />,
                        <FormikCheckboxField
                            name="round_trip"
                            id="round_trip"
                            label={t("cargoSearch.additional_field.round_trip_box")}
                        />,
                    ]}
                />
            </div>
        </>
    );
};

export default ExtraOptions;
